import React from 'react';

const AdminDashboard = () => (
  <div className="admin-dashboard">
    <h2>Admin Dashboard</h2>
    <p>Welcome to the admin dashboard. Select a section from sidebar (not implemented).</p>
  </div>
);

export default AdminDashboard;
